<template>
  <v-container>
    <perseu-card title="Configurações gerais do app">
      <template #content>
        <perseu-input-file-aws
          label="Termo de consentimento"
          :value="consentTerm"
          @input="handleChangeConsentForm"
        >
          <template #additionalInfo>
            <p v-if="lastUpdate">
              Ultima atualização em: {{ lastUpdate | formatDateTime }}
            </p>
            <p v-else>Nenhum arquivo enviado.</p>
          </template>
        </perseu-input-file-aws>
        
        <v-divider class="mt-10 my-5"></v-divider>
        
        <div class="mb-4 mx-2">
          <h3 class="text-subtitle-1 font-weight-medium mb-3">Cache do Aplicativo Terapeuta</h3>
          <div class="px-5 d-flex align-center">
            <div class="flex-grow-1">
              <p class="text-body-2 grey--text text--darken-1 mb-0">
                O último carregamento ocorreu em <b>{{ lastCacheLoad }}</b><br><br>
                Reiniciar o cache força a atualização de todos os dados e a sincronização do Aplicativo Terapeuta.<br>
                Use esta opção quando fizer alterações que precisam ser imediatamente disponibilizadas.<br>
                O tempo de recarregamento automático do cache é de até 10 minutos.<br>
              </p>
            </div>
            <div class="mr-4 d-flex justify-center">
              <v-btn 
                color="success"
                :loading="isResetingCache"
                @click="resetSystemCache"
              >
                <v-icon left>mdi-cached</v-icon>
                Reiniciar Cache
              </v-btn>
            </div>
          </div>
        </div>
      </template>
    </perseu-card>
  </v-container>
</template>

<script>
import * as moment from 'moment';
import {
  resetCache,
  getCacheState,
  getAllSettings,
  saveConsentFormUrl,
} from "@/services/settings-service";

export default {
  name: "GeneralSettings",
  components: {
    "perseu-input-file-aws": () =>
      import("@/components/shared/PerseuInputFileAWS"),
  },
  data: () => ({
    consentTerm: "",
    lastUpdate: "",
    lastCacheLoad: "",
    lastCacheHash: "",
    isResetingCache: false,
  }),
  mounted() {
    this.loadSettings();
    this.loadCacheState();
  },
  methods: {
    async loadSettings() {
      const { data } = await getAllSettings();
      this.consentTerm = data?.consentTermUrl;
      this.lastUpdate = data?.updatedAt;
    },
    async loadCacheState() {
      const { data } = await getCacheState();
      this.lastCacheLoad = !!data?.timestamp
        ? moment(data.timestamp).format("DD/MM/YYYY HH:mm:ss")
        : 'Nenhum carregamento concluído ainda';
    },
    async handleChangeConsentForm(newUrl) {
      const { data } = await saveConsentFormUrl(newUrl);
      this.consentTerm = data?.consentTermUrl;
      this.lastUpdate = data?.updatedAt;
      this.$toasted.global.defaultSuccess();
    },
    async resetSystemCache() {
      this.isResetingCache = true;
      try {
        const data = await resetCache();
        this.$toasted.global.defaultSuccess({ 
          message: "Cache do sistema reiniciado com sucesso!" 
        });

        this.lastCacheLoad = moment(data.timestamp).format("DD/MM/YYYY HH:mm:ss");

      } catch (error) {
        this.$toasted.global.defaultError({ 
          message: "Erro ao reiniciar o cache do sistema" 
        });
      } finally {
        this.isResetingCache = false;
      }
    },
  },
};
</script>

<style scoped></style>
